module.exports = __webpack_public_path__ + "static/media/Dashboardwithbg.de8f0431.svg";